import React from 'react';
import Typography from '@mui/material/Typography';

export type CommonInputProps = {
  label?: string | React.ReactNode;
  name: string;
};

export type SelectInputOption = {
  label: string;
  value: number | string;
  disabled?: boolean;
};
export type SelectInputProps = { options: SelectInputOption[] };

export const Error = ({ error }: any) => {
  return (
    <Typography color="error">
      {error.message}
    </Typography>
  );
};

export const getError = (name: string, errors: any): any => {
  if (!errors) {
    return;
  }

  if (name.includes('.')) {
    const split = name.split('.');

    let error = null;

    for (let i = 0; i < split.length; i += 1) {
      if (error && error[split[i]]) {
        error = error[split[i]]
      } else if (errors[split[i]]) {
        error = errors[split[i]];
      } else {
        return null;
      }
    }

    return error;
  }

  return errors[name];
};